var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.122,
    height: 32.496,
    viewBox: "0 0 43.122 32.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0.217 -0.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2115",
    "data-name": "Trazado 2115",
    d: "M9.177,9.355H35.06A2.677,2.677,0,0,0,35.06,4H9.177a2.677,2.677,0,0,0,0,5.355Z",
    transform: "translate(0 -2.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2116",
    "data-name": "Trazado 2116",
    d: "M35.06,11H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z",
    transform: "translate(0 3.158)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2117",
    "data-name": "Trazado 2117",
    d: "M35.06,18H9.177a2.677,2.677,0,0,0,0,5.355H35.06a2.677,2.677,0,0,0,0-5.355Z",
    transform: "translate(0 8.653)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.94ea487162ac014cf49451d1f2535222.svg";
export { ForwardRef as ReactComponent };